import AppFlowActions from '../../constants';

/**
 *
 * @param {*} data
 */
export default function loadingPage(data) {
  return ({ type: AppFlowActions.LOADING_COMPLETE, isLoading: data });
}
